<template>
  <div>
    <vs-input :type="field.type"
              :placeholder="field.title"
              icon="mode_edit"
              :label="field.title +' *'"
              v-model="field.value"
              class="mt-3 w-100"
              :disabled="!edit"/>
  </div>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      default: {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  }
}
</script>